import { useEffect, useState } from 'react'
import { type Connector, useConnect } from 'wagmi'
import { Button, type ButtonProps } from '../common/button'

interface WalletButtonProps extends ButtonProps {
  connector: Connector
}

export const WalletButton = ({ connector, ...props }: WalletButtonProps) => {
  const [ready, setReady] = useState(false)
  const { mutate: connect } = useConnect()

  useEffect(() => {
    ;(async () => {
      const provider = await connector.getProvider()
      setReady(!!provider)
    })()
  }, [])

  return <Button disabled={!ready} onClick={() => connect({ connector })} {...props} />
}
